import { app } from '../../../../../app';
import { Controller } from './regular-saaspass-app-users.controller';

app.component('companyUserDirectoriesSaaspassUsersRegularSaaspassAppUsers', {
    bindings: {
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./regular-saaspass-app-users.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/regular-saaspass-app-users/regular-saaspass-app-users.component.js